import ServicePage from './ServicePage';

const Psychoeducation = () => <ServicePage serviceKey="psychoeducation" />;

export default Psychoeducation;
